/**
 * Shared pdf.js options for every PDF we render.
 *
 * `isEvalSupported: false` turns off pdf.js's PostScript function compiler,
 * which builds Type 4 (calculator) shading functions by calling `eval`. We
 * render provider-uploaded PDFs, so that path takes untrusted input; the
 * interpreter fallback is slower but only for the rare PDFs that use those
 * functions. Also a prerequisite for serving a CSP without `unsafe-eval`.
 *
 * Must stay a module-level constant: react-pdf reloads the document whenever
 * the `options` prop changes identity, so an inline object literal would
 * re-fetch on every render.
 */
export const PDF_DOCUMENT_OPTIONS = {
  isEvalSupported: false,
} as const;
